export const DASHBOARD_TASKS_ANCHOR = 'tasks';

export const DASHBOARD_TASKS_PATH = `/dashboard#${DASHBOARD_TASKS_ANCHOR}`;

export const hashMatchesAnchor = (hash: string, anchor: string): boolean =>
  hash === `#${anchor}`;
